import React from 'react';

const Footer = () => (
  <div className="footer">
    <div className="secondary-footer">
      <div className="container">
        <span className="copy-right">&copy; {new Date().getFullYear()} - Health Services Advisory Group. All rights Reserved.</span>
      </div>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/modules/layout/components/Footer.js